/******************************************************************************
 *** BudgetViewFile ** 첨부파일 확인 & 다운로드/미리보기
*******************************************************************************/
import React from "react";
import Axios from "@/js/common/Axios";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { budgetFilesProps } from "@/js/common/types/types";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "../../common/DialogTitleBar";
import PreViewFile from "./PreViewFile";

interface Props {
    fileSeCd: string;    // 파일 구분 코드
    savedBudgetFiles: budgetFilesProps[];
    width?: string;
    height?: string;
}

const BudgetViewFile = ({fileSeCd, savedBudgetFiles, width = "320px", height = "50px"}: Props) => {
    const [previewModalOpen, setPreviewModalOpen] = React.useState(false); // 미리보기 모달
    const [blobUrl , setBlobUrl ] = React.useState(""); // 파일 Blob URL
    const [fileName, setFileName] = React.useState(""); // 파일 이름

    // 첨부파일 다운로드
    const handleDownload = (item: any) => {
        Axios.dataAccess({
            url: "system/com/file/download-budget-file.do",
            methodType: "get",
            responseType: "blob",
            paramData: {
                docId: item.docId,
                fileSn: item.fileSn,
                fileSeCd: item.fileSeCd ?? fileSeCd,
            },
        });
    };

    // 파일 확장자 확인
    const getFileExtension = (name: string): string => {
        const lastDot = name.lastIndexOf(".");
        return lastDot >= 0 ? name.substring(lastDot + 1).toLowerCase() : "";
    };

    // 미리보기 버튼 표시
    const isPreviewableFile = (fileName: string) => {
        const ext = getFileExtension(fileName);
        return ["pdf", "jpg", "jpeg", "png", "gif", "bmp"].includes(ext);
    };

    // PDF, 이미지 파일 미리보기
    const handlePreview = (item: any) => {
        Axios.dataAccess({
            url: "system/com/file/download-budget-file.do",
            methodType: "get",
            responseType: "blob",
            disableDownloadOnBlob: true,
            paramData: {
                docId: item.docId,
                fileSn: item.fileSn,
                fileSeCd: item.fileSeCd ?? fileSeCd,
            },
            onSuccessFn: (res: any) => {
                setBlobUrl(res.blobUrl);
                setFileName(res.fileName || item.fileNm);
                setPreviewModalOpen(true);
            },
        });
    };

    return (
    <>
        {savedBudgetFiles.length === 0 && (
            <div className="dpFlx flxdCol">
                <div className="h30 dpFlx aiE pb5">
                    <span className="fm-b fs13 ls06 fc111111">첨부파일</span>
                </div>
                <div className="bd1 bdrd2 bdcDDDDDD bgcF6F6F6 taC h30 pt5">
                    <span className="SpoqaHanSansNeo-Medium fs14 ls075 fc008418">조회된 첨부파일 없습니다.</span>
                </div>
            </div>
        )}
        {savedBudgetFiles.length > 0 && (
            <div className="dpFlx flxdCol">
                <div className="h30 dpFlx aiE pb5">
                    <span className="fm-b fs13 ls06 fc111111">첨부파일</span>
                </div>
                <div className="bd1 bdcDDDDDD bgcF6F6F6">
                    <div className="w100p dpFlx flxdCol pl10 pr10 pb3 pt2 bdBox">
                        {savedBudgetFiles.map((item: any, idx: number) => (
                            <div key={idx} className="w100p dpFlx aiC jcSb" style={{ height: "30px" }}>
                                <div className="dpFlx aiC tdU-hover fc5C93FF-hover csP"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(item);
                                    }}
                                >
                                    <AttachFileIcon style={{ fontSize: 18, color: "#1E466A" }} />
                                    <span className="SpoqaHanSansNeo-Medium fs14 ls075 fc008418">
                                        {item.fileNm}
                                    </span>
                                </div>
                                {isPreviewableFile(item.fileNm) && (
                                    <button type="button" className="SpoqaHanSansNeo-Medium fs12 ls075"
                                        style={{
                                            border: "1px solid #D0D0D0", borderRadius: "4px",
                                            backgroundColor: "#FFFFFF", color: "#1E466A",
                                            padding: "2px 8px", marginRight: "15px", cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handlePreview(item);
                                        }}
                                    >
                                        미리보기
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )}

        <Modal modalOpen={previewModalOpen} dim={true} visible={true}width={940}
            titleEl={<DialogTitleBar title={"파일 미리보기"} />} onCloseFunc={() => setPreviewModalOpen(false)}
        >
            <PreViewFile blobUrl={blobUrl} fileName={fileName} />
        </Modal>
    </>
    )
};

export default BudgetViewFile;